export default "__VITE_ASSET__BmRvY5te__"